import { EffectCallback, useEffect } from 'react';

type ConditionalWrapperProps = {
  children: React.ReactElement,
  condition: boolean,
  wrapper: (children: React.ReactElement) => JSX.Element,
};

export const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

/* eslint-disable */
export const onComponentDidMount = (effect: EffectCallback) => useEffect(
  effect,
  ['componentDidMount']
);
/* eslint-enable */
